import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT } from '@angular/common';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PreconnectService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document
  ) {}

  setupPreconnectLinks(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const origins = new Set<string>();

    try {
      origins.add(new URL(environment.WEB_URL).origin);
    } catch {}

    try {
      origins.add(new URL(environment.API_URL).origin);
    } catch {}

    origins.forEach((origin) => {
      if (!origin) {
        return;
      }

      const existing = this.document.head.querySelector(
        `link[rel="preconnect"][href="${origin}"]`
      );
      if (existing) {
        return;
      }

      const link = this.document.createElement('link');
      link.rel = 'preconnect';
      link.href = origin;
      link.crossOrigin = 'anonymous';
      this.document.head.appendChild(link);
    });
  }
}

